import { Injectable } from '@angular/core';
import { Subdivision } from './../subdivisions/subdivision';
import { City } from './../cities/city';
import { Observable, throwError, of, Subject, BehaviorSubject } from 'rxjs';
import { retry, catchError, map, finalize, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { MessagerComponent } from '../messager/messager/messager.component';
import { MatRipple } from '@angular/material/core';


@Injectable({
  providedIn: 'root'
})

export class RippleService {

  basicRipple(theRipple: MatRipple) {
    const ripRef = theRipple.launch({
      persistent: true,
      centered: true,
      color: 'lightgreen'
    });
    ripRef.fadeOut();
  }

  longRipple(theRipple: MatRipple) {
    const ripRef = theRipple.launch({
      persistent: true,
      centered: true,
      color: 'lightgreen',
      animation: {
        enterDuration : 1000,
        exitDuration : 2000
      }
    });
    ripRef.fadeOut();
  }

}



